import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { VulnerabilityInstance } from "../../components/Vulnerability";
import { VulnerabilityInstanceData, getVulnerabilityInstance } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreeVulnerability = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [vulnerabilityData, setVulnerabilityData] = useState<VulnerabilityInstanceData | null>(null);
	useEffect(() => {
		getVulnerabilityInstance(entityId, (data, resp) => {
			if (data) {
				setVulnerabilityData(data);
			} else {
				setVulnerabilityData(null);
			}
		});
	}, [setVulnerabilityData]);

	return (vulnerabilityData ? <>
		<Header />
		<Container>
			<VulnerabilityInstance id={entityId} data={vulnerabilityData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={vulnerabilityData.children} />
		</Container>
	</> : <CircularProgress />)
}
